import Loader from '@basic/Loader';
import GoalCardsGrid from '@components/goals/GoalCardsGrid';
import { useGoalsService } from '@hooks';
import { GoalModel } from '@models/goals';
import { setupForDark } from '@theme';
import classNames from 'classnames';
import { useEffect, useRef, useState } from 'react';
import { usePaymentAndOrder } from '../../payments/PaymentAndOrderContext';
import { useLandingPageTranslation } from './useLandingPageTranslation';

export default function GoalLandingPageRecommendations() {
  const { state } = usePaymentAndOrder();
  const { getGoals, isPendingGetGoals } = useGoalsService();
  const [goals, setGoals] = useState<GoalModel[]>([]);
  const previousSimilarEntityIdsRef = useRef<string[] | undefined>(undefined);
  const { t } = useLandingPageTranslation();

  const currentSimilarEntityIds = state.goal?.landingPage?.recommendedGoals?.similarEntityIds;

  // Clear goals when similarEntityIds change
  useEffect(() => {
    const currentIds = currentSimilarEntityIds?.join(',');
    const previousIds = previousSimilarEntityIdsRef.current?.join(',');

    if (currentIds !== previousIds) {
      setGoals([]);
      previousSimilarEntityIdsRef.current = currentSimilarEntityIds;
    }
  }, [currentSimilarEntityIds]);

  useEffect(() => {
    if (currentSimilarEntityIds && currentSimilarEntityIds.length > 0) {
      getGoals({ goalEntityIds: currentSimilarEntityIds }).then(({ goals }) => setGoals(goals));
    }
  }, [currentSimilarEntityIds]);

  if (!currentSimilarEntityIds || currentSimilarEntityIds.length === 0) {
    return <></>;
  }

  if (
    !state.goal?.landingPage?.recommendedGoals?.similarEntityIds ||
    state.goal?.landingPage?.recommendedGoals?.similarEntityIds.length === 0
  ) {
    return <></>;
  }

  if (isPendingGetGoals) {
    return <Loader />;
  }

  return (
    <div
      id='recommendations'
      className={classNames(
        'w-full flex flex-col items-center',
        // RESPONSIVE STYLES
        'gap-xl @[640px]:gap-xxxl',
        'py-xl @[640px]:py-huge',
        'px-sm @[640px]:px-none'
      )}
    >
      <div className={classNames('w-full flex flex-col items-center gap-xl max-w-[1200px]')}>
        <div className={classNames('flex flex-col gap-md items-center justify-center')}>
          <div
            className={classNames(
              'font-bold',
              setupForDark('text-white'),
              // RESPONSIVE STYLES
              'text-[32px] @[640px]:text-[48px]'
            )}
          >
            {t('domains.goals.landingPage.recommendations.title')}
          </div>
          <div
            className={classNames(
              'w-full font-normal leading-[1.6]',
              setupForDark('text-white'),
              // RESPONSIVE STYLES
              'text-[16px] @[640px]:text-[20px]'
            )}
          >
            {t('domains.goals.landingPage.recommendations.subtitle')}
          </div>
        </div>
        <GoalCardsGrid goals={goals} className='!px-sm' />
      </div>
    </div>
  );
}
